import { faTimesCircle } from "@fortawesome/pro-regular-svg-icons/faTimesCircle";
import { faCheckCircle } from "@fortawesome/pro-solid-svg-icons/faCheckCircle";
import ConditionalIcon from "~/conditional-icon";
import None from "~/none";

import "./boolean-icon.scss";
import { IProps } from "./boolean-icon.types";

/**
 * Show an icon to represent a true or false value.
 * @param props Boolean value.
 * @returns     Icons representing true or false.
 */
const BooleanIcon = ({ value }: IProps) => {
    if (typeof value !== "boolean") {
        return <None>N/A</None>;
    }

    return (
        <div className="boolean-icon">
            <ConditionalIcon
                className={value ? "boolean-icon--true" : "boolean-icon--false"}
                condition={value}
                iconFalse={faTimesCircle}
                iconTrue={faCheckCircle}
            />
        </div>
    );
};

export default BooleanIcon;
